import React from 'react'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)
const MOD = isMac ? '⌘' : 'Ctrl'

const GROUPS = [
  {
    title: 'Anywhere in Project Central',
    keys: [
      [['c'], 'Create a task'],
      [['/'], 'Search tasks'],
      [[MOD, 'K'], 'Search tasks'],
      [['?'], 'Show these shortcuts'],
      [['g', 'f'], 'Go to For you'],
      [['g', 'i'], 'Go to Search issues'],
      [['g', 'p'], 'Go to all projects'],
      [['g', 'b'], 'Go to the board (inside a project)'],
      [['g', 'l'], 'Go to the list (inside a project)']
    ]
  },
  {
    title: 'On a task',
    keys: [
      [['j'], 'Next task'],
      [['k'], 'Previous task'],
      [['a'], 'Assign to me'],
      [['m'], 'Write a comment'],
      [['s'], 'Start or stop the timer'],
      [['Esc'], 'Back']
    ]
  }
]

const Key = ({ children }) => (
  <kbd className="inline-flex min-w-[1.5rem] justify-center rounded border bg-muted px-1.5 py-0.5 font-mono text-[11px]">{children}</kbd>
)

// Opened with "?" (see useKeyboardShortcuts)
const ShortcutHelpDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-lg">
      <DialogHeader>
        <DialogTitle>Keyboard shortcuts</DialogTitle>
        <DialogDescription>Shortcuts don't fire while you're typing in a field. For two-key shortcuts, press the keys one after the other.</DialogDescription>
      </DialogHeader>
      <div className="grid gap-5 sm:grid-cols-2">
        {GROUPS.map(group => (
          <div key={group.title} className="space-y-2">
            <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{group.title}</p>
            <ul className="space-y-1.5">
              {group.keys.map(([keys, label]) => (
                <li key={label + keys.join()} className="flex items-center justify-between gap-3 text-sm">
                  <span>{label}</span>
                  <span className="flex items-center gap-1 shrink-0">
                    {keys.map((k, i) => (
                      <React.Fragment key={k}>
                        {i > 0 && keys[0] === 'g' && <span className="text-[10px] text-muted-foreground">then</span>}
                        <Key>{k}</Key>
                      </React.Fragment>
                    ))}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
)

export default ShortcutHelpDialog
